import { LISTING_TRANSITION_REASON } from '../../../../RentalPortalListing'

export const LISTING_READINESS_KEY = {
  description: 'description',
  photo: 'photo',
  portal: 'portal',
  rent: 'rent',
}

export const LISTING_SCHEDULE_ACTION = {
  deactivate: 'deactivate',
  goLive: 'go_live',
}

export const LISTING_SCHEDULE_REFUSAL_TEXT_KEY = {
  [LISTING_SCHEDULE_ACTION.deactivate]:
    'RentalPortal.ListingScheduleRefusalDeactivateKey',
  [LISTING_SCHEDULE_ACTION.goLive]:
    'RentalPortal.ListingScheduleRefusalGoLiveKey',
}

export const LISTING_SCHEDULE_REFUSAL_REASON_KEY = {
  [LISTING_SCHEDULE_ACTION.deactivate]: {
    [LISTING_TRANSITION_REASON.wrongStatus]:
      'RentalPortal.ListingDeactivateOnlyPublishedTooltipKey',
  },
  [LISTING_SCHEDULE_ACTION.goLive]: {
    [LISTING_TRANSITION_REASON.archived]:
      'RentalPortal.ListingScheduleRefusalArchivedKey',
    [LISTING_TRANSITION_REASON.flatAlreadyPublished]:
      'RentalPortal.ListingScheduleRefusalFlatPublishedKey',
    [LISTING_TRANSITION_REASON.flatPublicationInProgress]:
      'RentalPortal.ListingScheduleRefusalFlatInProgressKey',
    [LISTING_TRANSITION_REASON.noPortalSelected]:
      'RentalPortal.ListingScheduleRefusalNoPortalKey',
    [LISTING_TRANSITION_REASON.readinessIncomplete]:
      'RentalPortal.ListingScheduleRefusalMissingKey',
    [LISTING_TRANSITION_REASON.wrongStatus]:
      'RentalPortal.ListingScheduleRefusalLetKey',
  },
}

export const LISTING_READINESS_SKELETON_ROW_COUNT = 3

export const QA_NAME_LISTING_PROFILE_READINESS_COLLAPSE_BTN =
  'listingProfileReadinessCollapse'

export const QA_NAME_LISTING_PROFILE_READINESS_FIX_BTN =
  'listingProfileReadinessFix'

export const QA_NAME_LISTING_PROFILE_MANAGE_PUBLISHING_BTN =
  'listingProfileManagePublishing'

export const QA_NAME_LISTING_PROFILE_SCHEDULE_REFUSAL =
  'listingProfileScheduleRefusal'
